import AccessPage from "../Pages/AccessPage";
import MainPage from "../Pages/MainPage";
import MainLayout from "../Components/Layout/MainLayout";
import LoginLayout from "../Components/Layout/LoginLayout";
import Router from "../Resources/Router.json";

export const AllRouter = [
    {
        Layout: MainLayout,
        Path: [`/${Router.MainPage}`],
        Routers: [
            { path: `/${Router.MainPage}`, component: MainPage }
        ]
    },
    {
        Layout: LoginLayout,
        Routers: [
            { path: `/`, component: AccessPage, exact: true }
        ]
    }
]
